import { clearPortalDashboardCache } from './portalDashboardCache.js'

const TOKEN_KEY = 'support_client_token'
const CLIENT_KEY = 'support_client_profile'

export function getClientToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || ''
  } catch {
    return ''
  }
}

export function setClientSession({
  token,
  client,
  staff,
  installations,
  organizations,
  permissions,
  actor_type,
}) {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token)
      clearPortalDashboardCache()
    }
    localStorage.setItem(
      CLIENT_KEY,
      JSON.stringify({
        client: client || null,
        staff: staff || null,
        installations: installations || [],
        organizations: organizations || [],
        permissions: permissions || [],
        actor_type: actor_type || (staff ? 'staff' : 'client'),
      })
    )
  } catch (_) {}
}

export function clearClientSession() {
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(CLIENT_KEY)
    clearPortalDashboardCache()
  } catch (_) {}
}

export function getClientSession() {
  try {
    const raw = localStorage.getItem(CLIENT_KEY)
    return raw
      ? JSON.parse(raw)
      : { client: null, staff: null, installations: [], organizations: [], permissions: [], actor_type: null }
  } catch {
    return { client: null, staff: null, installations: [], organizations: [], permissions: [], actor_type: null }
  }
}

export function isClientLoggedIn() {
  return getClientToken().length >= 32
}

export function hasPermission(name) {
  const session = getClientSession()
  const perms = session.permissions || []
  if (session.staff?.is_superadmin) return true
  return perms.includes(name)
}
